import { withCustomMetrics } from '@zocdoc-frontend-common/utils-frontend-metrics';
import AppointmentDetailsFormView from './AppointmentDetailsFormView';

const AppointmentDetailsForm = withCustomMetrics({
    component: 'Appointment Details Form',
    element: 'Appointment Details Form',
})(AppointmentDetailsFormView);

export default AppointmentDetailsForm;
